import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AIAgentComponent } from './components/ai-agent/ai-agent-bot.component';
import { ContentRendererComponent } from './components/content-renderer/content-renderer.component';
import { AIAgentService } from './services/ai-agent.service';
import { GlobalSearchFiltersModule } from '../../shared-ui-refresh/global-search-filters/global-search-filters.module';
import { ChipListComponent } from './components/chip-list/chip-list.component';
import { ChatFlyoutComponent } from './components/flyout/chat-flyout.component';
import { UserFeedbackComponent } from './components/user-feedback/user-feedback.component';
import { AIAgentServiceConfig } from './services/ai-agent.service.config';
import { ChatHistoryListComponent } from './components/chat-history-list/chat-history-list.component';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { RefreshLoaderModule } from '../../shared/loader/refresh-loader.module';

@NgModule({
    declarations: [
        AIAgentComponent,
        ContentRendererComponent,
        ChipListComponent,
        ChatFlyoutComponent,
        UserFeedbackComponent,
        ChatHistoryListComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        GlobalSearchFiltersModule,
        RefreshLoaderModule,
            TranslateModule.forChild({
                  loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix: '.json?v=' + Date.now()}),

            })
    ],
    providers: [
        AIAgentService,
        AIAgentServiceConfig
    ],
    exports: [
        AIAgentComponent,
        TranslateModule
    ]
})
export class AIAgentModule { }